
<template>
  <div class="mw100" style="margin-top: 20px">
    <div
      class="component_card"
      style="border: 1px solid rgb(216, 214, 214); background: #fff; width: 100%;"
    >
      <div class="p20" style="border-bottom: solid 1px #d8d6d6">
        <h1 class="main_blue_dk_fill fat">{{ $t("msg.table_failed_1") }}</h1>
        <!-- <p>{{$t('msg.table_failed_2')}}</p> -->
      </div>

      <div class="p10">
        <div
          class="order columns"
          v-for="(item, index) in failedOrders"
          :key="item"
          v-if="index < 5"
          style="display: flex; justify-content: space-between; font-size: 13px"
        >
          <div class="column is-one-quarter">
            {{ fixTimeZone(item.updatedAt) }} UTC -3
          </div>
          <div class="column is-one-quarter upper tal_c">
            {{ $t("msg.withdraw") }}
          </div>
          <div class="column is-one-quarter capitalize">{{ item.status }}</div>
          <div class="column is-one-quarter">
            <div>
              <!-- <button class="default-button main_green_md_bg" @click="continueTransaction(item)">{{$t('msg.continue')}}</button> -->
              <button
                v-if="!loading"
                class="default-button main_red_lt_bg m10_t"
                @click="cancelTransaction(item.id)"
              >
                {{ $t("msg.cancel") }}
              </button>
              <button
                v-if="loading"
                class="default-button main_red_lt_bg m10_t"
              >
                <Loading />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import spacetime from "spacetime";
import Loading from "../../../components/public/Loading";

export default {
  props: ["failedOrders"],
  created() {},
  mounted() {},
  data: () => ({
    loading: false,
  }),
  components: {
    Loading,
  },
  methods: {
    continueTransaction(el) {
      this.$emit("continueTransaction", el);
    },

    cancelTransaction(el) {
      this.loading = true;
      this.$emit("cancelTransaction", el);
    },
  },
  computed: {},
  watch: {},
};
</script>


// WEBPACK FOOTER //
// src/components/private/services/FailedTable.vue